import axios from "axios";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../../button/back";

const MAX_DIMENSI = 4;

const MASTER_DIMENSI = [
  {
    no: 1,
    dimensi: "Keimanan dan Ketakwaan terhadap tuhan yang maha Esa",
    sub: "Hubungan dengan Tuhan Yang Maha Esa.",
  },
  {
    no: 2,
    dimensi: "Keimanan dan Ketakwaan terhadap tuhan yang maha Esa",
    sub: "Hubungan sesama manusia.",
  },
  {
    no: 3,
    dimensi: "Keimanan dan Ketakwaan terhadap tuhan yang maha Esa",
    sub: "Hubungan dengan Lingkungan Alam.",
  },
  { no: 4, dimensi: "Kewargaan", sub: "Kewargaan Lokal." },
  { no: 5, dimensi: "Kewargaan", sub: "Kewargaan Nasional." },
  { no: 6, dimensi: "Kewargaan", sub: "Kewargaan Global." },
  { no: 7, dimensi: "Penalaran Kritis", sub: "Penyampaian Argumentasi." },
  { no: 8, dimensi: "Penalaran Kritis", sub: "Pengambilan keputusan." },
  { no: 9, dimensi: "Penalaran Kritis", sub: "Penyelesaian Masalah." },
  { no: 10, dimensi: "Kreativitas", sub: "Gagasan Baru." },
  { no: 11, dimensi: "Kreativitas", sub: "Fleksibilitas berpikir." },
  { no: 12, dimensi: "Kreativitas", sub: "Karya." },
  { no: 13, dimensi: "Kemandirian", sub: "Bertanggung Jawab." },
  { no: 14, dimensi: "Kemandirian", sub: "Kepemimpinan." },
  { no: 15, dimensi: "Kemandirian", sub: "Pengembangan diri." },
  { no: 16, dimensi: "Kolaborasi", sub: "Peduli." },
  { no: 17, dimensi: "Kolaborasi", sub: "Berbagi." },
  { no: 18, dimensi: "Kolaborasi", sub: "Kerjasama." },
  { no: 19, dimensi: "Komunikasi", sub: "Menyimak." },
  { no: 20, dimensi: "Komunikasi", sub: "Membaca." },
  { no: 21, dimensi: "Komunikasi", sub: "Menulis." },
  { no: 22, dimensi: "Komunikasi", sub: "Berbicara." },
  { no: 23, dimensi: "Kesehatan", sub: "Hidup bersih dan sehat." },
  {
    no: 24,
    dimensi: "Kesehatan",
    sub: "Kebugaran, kesehatan fisik dan mental.",
  },
  { no: 25, dimensi: "Kesehatan", sub: "Kesehatan Lingkungan." },
];

const AddKokulikuler = () => {
  const { id } = useParams();
  const [form, setForm] = useState({
    kelas: "",
    rombel: "",
    tahun: "",
    semester: "",
  });

  const [judulKokulikuler, setJudulKokulikuler] = useState([""]);
  const [pilihanDimensi, setPilihanDimensi] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const MAX_JUDUL = 2;

  /* ================= FORM ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= JUDUL ================= */
  const handleJudulChange = (index, value) => {
    const updated = [...judulKokulikuler];
    updated[index] = value;
    setJudulKokulikuler(updated);
  };

  const addJudul = () => {
    if (judulKokulikuler.length >= MAX_JUDUL) return;
    setJudulKokulikuler([...judulKokulikuler, ""]);
  };

  const removeJudul = (index) => {
    if (judulKokulikuler.length === 1) return;
    setJudulKokulikuler(judulKokulikuler.filter((_, i) => i !== index));
  };

  /* ================= DIMENSI ================= */
  const toggleDimensi = (item) => {
    const exists = pilihanDimensi.some(
      (d) => d.DimensiProfile === item.dimensi && d.SubDimensi === item.sub,
    );

    if (exists) {
      setPilihanDimensi((prev) =>
        prev.filter(
          (d) =>
            !(d.DimensiProfile === item.dimensi && d.SubDimensi === item.sub),
        ),
      );
    } else {
      if (pilihanDimensi.length >= MAX_DIMENSI) return;
      setPilihanDimensi((prev) => [
        ...prev,
        { DimensiProfile: item.dimensi, SubDimensi: item.sub },
      ]);
    }
  };

  /* ================= CEK DUPLIKASI ================= */
  const checkExisting = async () => {
    try {
      await axios.get(
        `${process.env.REACT_APP_API_URL}api/kokulikuler/${form.kelas}/${form.rombel}/${form.tahun}/${form.semester}`,
      );
      return true;
    } catch (err) {
      if (err.response?.status === 404) return false;
      throw err;
    }
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Object.values(form).some((v) => !v)) {
      return alert("Semua field wajib diisi");
    }

    if (judulKokulikuler.some((j) => !j.trim())) {
      return alert("Judul kokulikuler tidak boleh kosong");
    }

    if (pilihanDimensi.length === 0 || pilihanDimensi.length > 4) {
      return alert("Pilih minimal 1 dan maksimal 3 Sub Dimensi");
    }

    try {
      setLoading(true);

      const isDuplicate = await checkExisting();
      if (isDuplicate) return alert("Data kokulikuler sudah ada");

      await axios.post(`${process.env.REACT_APP_API_URL}api/kokulikuler`, {
        ...form,
        judulKokulikuler,
        pilihanDimensi,
        profileLulusan: [],
      });

      alert("Data kokulikuler berhasil disimpan");

      setForm({ kelas: "", rombel: "", tahun: "", semester: "" });
      setJudulKokulikuler([""]);
      setPilihanDimensi([]);
    } catch (err) {
      console.error(err);
      alert("Gagal menyimpan data");
    } finally {
      setLoading(false);
    }
  };

  /* ================= JSX ================= */
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-xl font-bold mb-4">Tambah Kokulikuler</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <select
            name="kelas"
            value={form.kelas}
            onChange={handleChange}
            className="border p-2 rounded"
          >
            <option value="">Pilih Kelas</option>
            {[1, 2, 3, 4, 5, 6].map((k) => (
              <option key={k} value={k}>
                Kelas {k}
              </option>
            ))}
          </select>

          <select
            name="rombel"
            value={form.rombel}
            onChange={handleChange}
            className="border p-2 rounded"
          >
            <option value="">Pilih Rombel</option>
            {["A", "B", "C", "D"].map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>

          <input
            name="tahun"
            value={form.tahun}
            onChange={handleChange}
            placeholder="Tahun (contoh 2025)"
            className="border p-2 rounded"
          />

          <select
            name="semester"
            value={form.semester}
            onChange={handleChange}
            className="border p-2 rounded"
          >
            <option value="">Pilih Semester</option>
            <option value="1">Semester 1</option>
            <option value="2">Semester 2</option>
          </select>
        </div>

        {/* JUDUL ARRAY */}
        <div className="space-y-2">
          <h2 className="font-semibold">Judul Kokulikuler</h2>

          {judulKokulikuler.map((judul, i) => (
            <div key={i} className="flex gap-2">
              <input
                value={judul}
                onChange={(e) => handleJudulChange(i, e.target.value)}
                className="border p-2 rounded w-full"
                maxLength={100}
                placeholder={`Judul ${i + 1}`}
              />
              <button
                type="button"
                onClick={() => removeJudul(i)}
                className="bg-red-500 text-white px-3 rounded"
              >
                ✕
              </button>
            </div>
          ))}

          {judulKokulikuler.length < MAX_JUDUL && (
            <button
              type="button"
              onClick={addJudul}
              className="text-blue-600 text-sm"
            >
              + Tambah Judul
            </button>
          )}
        </div>

        <button
          type="button"
          onClick={() => setShowModal(true)}
          className="bg-indigo-600 text-white px-4 py-2 rounded"
        >
          Pilih Dimensi Profil
        </button>

        <p className="text-sm">
          Dipilih maksimal: <b>{pilihanDimensi.length}</b> / {MAX_DIMENSI}
        </p>

        <button
          disabled={loading}
          className="bg-green-600 text-white px-6 py-2 rounded"
        >
          {loading ? "Menyimpan..." : "Simpan"}
        </button>
      </form>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white max-w-5xl w-full p-4 rounded max-h-[90vh] overflow-auto">
            <h2 className="font-bold mb-2">Dimensi Profil Lulusan</h2>
            <p className="text-sm text-red-600 mb-3">
              Maksimal memilih 4 Sub Dimensi
            </p>
            <table className="w-full border text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border p-2">Pilih</th>
                  <th className="border p-2">No</th>
                  <th className="border p-2">Dimensi</th>
                  <th className="border p-2">Sub Dimensi</th>
                </tr>
              </thead>
              <tbody>
                {MASTER_DIMENSI.map((item) => {
                  const checked = pilihanDimensi.some(
                    (d) =>
                      d.DimensiProfile === item.dimensi &&
                      d.SubDimensi === item.sub,
                  );
                  const disabled =
                    pilihanDimensi.length >= MAX_DIMENSI && !checked;
                  return (
                    <tr key={item.no} className={disabled ? "opacity-50" : ""}>
                      <td className="border p-2 text-center">
                        <input
                          type="checkbox"
                          checked={checked}
                          disabled={disabled}
                          onChange={() => toggleDimensi(item)}
                        />
                      </td>
                      <td className="border p-2">{item.no}</td>
                      <td className="border p-2">{item.dimensi}</td>
                      <td className="border p-2">{item.sub}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="text-right mt-4">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-600 text-white px-4 py-2 rounded"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center mt-5">
        <Link to={`/Kokurikuler/${id}`}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default AddKokulikuler;
